export const AIF_PROCESS_LIST_HELP_LANG_RESOURCES = {
  "zh-CHS": {
    "code": "编号",
    "name": "名称",
    "lastModifiedTime": "最后修改时间",
    "upBill": "上游单据",
    "downBill": "下游单据",
    "processName": "流程名称",
    "processType": "流程类型",
    "creation": "生单",
    "writeback": "回写",
    "enabledState": "启用状态",
    "sysInit": "系统预置",
    "filter": "筛选",
    "all": "全部",
    "enabled": "已启用",
    "disabled": "已禁用",
    "yes": "是",
    "no": "否",
    "billSelector": "单据选择",
    "querySolution": "筛选方案",
    "collapse": "收起",
    "expand": "展开",
    "loading": "加载中",
    "pleaseSelectNonVirtualVO": "请选择非虚拟VO",
    "pleaseSelectOneItemOnly": "请选中一条数据",
    "isExtendProcess": "扩展流程",
    "creationProcess": "生单流程",
    "clickCancel": "取消",
    "clickOk": "确定",
    "set": "（已设置）",
    "notSet": "（未设置）",
    "setProcess": "已设置：",
  },
  "en": {
    "code": "Code",
    "name": "Name",
    "lastModifiedTime": "Last Modified Time",
    "upBill": "Upstream Bill",
    "downBill": "Downstream Bill",
    "processName": "Process Name",
    "processType": "Process Type",
    "creation": "Creation",
    "writeback": "Writeback",
    "enabledState": "Enabled State",
    "sysInit": "System Init",
    "filter": "Filter",
    "all": "All",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "yes": "Yes",
    "no": "No",
    "billSelector": "Bill Selector",
    "querySolution": "Query Solution",
    "collapse": "Collapse",
    "expand": "Expand",
    "loading": "Loading...",
    "pleaseSelectNonVirtualVO": "Please select non-virtual VO",
    "pleaseSelectOneItemOnly": "Please select only one item",
    "isExtendProcess": "Extend Process",
    "creationProcess": "Rreation Process",
    "clickCancel": "Cancel",
    "clickOk": "Ok",
    "set": "(Set)",
    "notSet": "(Not set)",
    "setProcess": "Set: ",
  },
  "zh-CHT": {
    "code": "編號",
    "name": "名稱",
    "lastModifiedTime": "最後修改時間",
    "upBill": "上遊單據",
    "downBill": "下遊單據",
    "processName": "流程名稱",
    "processType": "流程類型",
    "creation": "生單",
    "writeback": "回寫",
    "enabledState": "啟用狀態",
    "sysInit": "系統預置",
    "filter": "篩選",
    "all": "全部",
    "enabled": "已啟用",
    "disabled": "已禁用",
    "yes": "是",
    "no": "否",
    "billSelector": "單據選擇",
    "querySolution": "篩選方案",
    "collapse": "收起",
    "expand": "展開",
    "loading": "加載中",
    "pleaseSelectNonVirtualVO": "請選擇非虛擬VO",
    "pleaseSelectOneItemOnly": "請選中壹條數據",
    "isExtendProcess": "擴展流程",
    "creationProcess": "生單流程",
    "clickCancel": "取消",
    "clickOk": "確定",
    "set": "（已設置）",
    "notSet": "（未設置）",
    "setProcess": "已設置：",
  }
};
